<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="name" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.会员名称')}}<template slot="title">{{$t('会员配置.会员名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="150" :placeholder="$t('通用.输入.请输入')+$t('会员配置.会员名称')" />
      </a-form-model-item>


<!--      <a-form-model-item prop="picture" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('会员配置.背景图')}}<template slot="title">{{$t('会员配置.背景图')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.picture" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('会员配置.背景图')" />-->
<!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('会员配置.背景图')" prop="picture" >
        <a-upload
          name="picture"
          listType="picture-card"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.picture"
            :src="form.picture"
            alt="picture"
            style="height: 102px; width: 102px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
          </div>
        </a-upload>
        <span>推荐尺寸 351 x 175</span>
      </a-form-model-item>



      <a-form-model-item prop="price" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.价格')}}<template slot="title">{{$t('会员配置.价格')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.price"  :placeholder="$t('通用.输入.请输入')+$t('会员配置.价格')" @change="limitMarketPrice()"/>
      </a-form-model-item>
      <a-form-model-item prop="consumeAmount" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.消费金额门槛')}}<template slot="title">{{$t('会员配置.消费金额门槛')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.consumeAmount" :min="0" :precision="2" style="width:100%"
          :placeholder="$t('通用.输入.请输入')+$t('会员配置.消费金额门槛')" />
      </a-form-model-item>
      <a-form-model-item prop="effective" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.有效期(单位:年)')}}<template slot="title">{{$t('会员配置.有效期(单位:年)')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.effective"  :placeholder="$t('通用.输入.请输入')+$t('会员配置.有效期(单位:年)')" />
      </a-form-model-item>
      <a-form-model-item prop="describe" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.说明')}}<template slot="title">{{$t('会员配置.说明')}}</template>
          </a-tooltip>
        </span>
        <a-textarea v-model="form.describe" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('会员配置.说明')" />
      </a-form-model-item>
      <a-form-model-item prop="zhuanxiangjifen" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.专享积分')}}<template slot="title">{{$t('会员配置.专享积分')}}</template>
          </a-tooltip>
        </span>
        <a-textarea v-model="form.zhuanxiangjifen" :placeholder="$t('通用.输入.请输入')+$t('会员配置.专享积分')"/>
      </a-form-model-item>


      <a-form-model-item prop="zhuanxiangyouhui" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.专享优惠')}}<template slot="title">{{$t('会员配置.专享优惠')}}</template>
          </a-tooltip>
        </span>
        <a-textarea v-model="form.zhuanxiangyouhui" :placeholder="$t('通用.输入.请输入')+$t('会员配置.专享优惠')"/>
      </a-form-model-item>
      <a-form-model-item prop="quanyihuodong" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.权益活动')}}<template slot="title">{{$t('会员配置.权益活动')}}</template>
          </a-tooltip>
        </span>
        <a-textarea v-model="form.quanyihuodong" :placeholder="$t('通用.输入.请输入')+$t('会员配置.权益活动')"/>
      </a-form-model-item>
      <a-form-model-item prop="huiyuanshengrili" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.会员生日礼')}}<template slot="title">{{$t('会员配置.会员生日礼')}}</template>
          </a-tooltip>
        </span>
        <a-textarea v-model="form.huiyuanshengrili" :placeholder="$t('通用.输入.请输入')+$t('会员配置.会员生日礼')"/>
      </a-form-model-item>
      <a-form-model-item prop="aicheshengrili" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.爱车生日礼')}}<template slot="title">{{$t('会员配置.爱车生日礼')}}</template>
          </a-tooltip>
        </span>
        <a-textarea v-model="form.aicheshengrili" :placeholder="$t('通用.输入.请输入')+$t('会员配置.爱车生日礼')"/>
      </a-form-model-item>
      <a-form-model-item prop="sort" >
        <span slot="label" >
          <a-tooltip>
            {{$t('会员配置.排序')}}<template slot="title">{{$t('会员配置.排序')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.sort"  :placeholder="$t('通用.输入.请输入')+$t('会员配置.排序')" />
      </a-form-model-item>
<!--      <a-form-model-item prop="remark" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('会员配置.备注')}}<template slot="title">{{$t('会员配置.备注')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMemberConfig, addMemberConfig, updateMemberConfig } from '@/api/memberConfig/memberConfig'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, generateRdStr, uploadObject, uploadOss} from "@/api/tool/oss";
import Editor from "@/components/Editor";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        picture: null,

        price: null,

        consumeAmount: null,

        effective: null,

        describe: null,

        zhuanxiangjifen: null,

        zhuanxiangyouhui: null,

        quanyihuodong: null,

        huiyuanshengrili: null,

        aicheshengrili: null,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: this.$t('会员配置.会员名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('会员配置.价格')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        effective: [
          { required: true, message: this.$t('会员配置.有效期(单位:年)')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        picture: null,
        price: null,
        consumeAmount: null,
        effective: null,
        describe: null,
        zhuanxiangjifen: null,
        zhuanxiangyouhui: null,
        quanyihuodong: null,
        huiyuanshengrili: null,
        aicheshengrili: null,
        sort: null,
        createTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMemberConfig({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateMemberConfig(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addMemberConfig(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    //上传图片
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'picture', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'posterPic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    //上传图片
    limitMarketPrice() {
      // console.log(i);
      let val = this.form.price.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val < 0) {
        val = ''
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.price = val
    },


  }
}
</script>
